import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import MailOutline from "@material-ui/icons/MailOutline";

// core components
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";

import { adminApi } from "functions/apis";

import RolePermissionList from "./RolePermissionList";
import RoleAvailablePermissionList from "./RoleAvailablePermissionList";

const useStyles = makeStyles(styles);

export default function RoleDetail(props) {
  const source = useRef(new AbortController());

  useEffect(() => {
    return () => source.current.abort();
  }, []);
  const { id } = useParams();
  const [reload, setReload] = React.useState({});
  const reloadHandler = () => {
    setReload({});
  };
  const [role, setRole] = React.useState(null);
  useEffect(() => {
    adminApi
      .get("/Roles/" + id, {
        signal: source.current.signal
      })
      .then(data => setRole(data))
      .catch(error => console.log(error));
  }, [id, reload]);

  const classes = useStyles();
  return (
    role !== null && (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>ROLE</h4>
            </CardHeader>
            <CardBody>
              <Button onClick={() => props.history.goBack()} value="Back">
                BACK
              </Button>
              <CustomInput
                labelText="Name"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  disabled: true,
                  value: role.name === null ? "" : role.name
                }}
              />
            </CardBody>
          </Card>
          <GridContainer>
            <GridItem xs={6} sm={6} md={6}>
              <RolePermissionList
                id={id}
                reloadHandler={reloadHandler}
                reload={reload}
              />
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <RoleAvailablePermissionList
                id={id}
                reloadHandler={reloadHandler}
                reload={reload}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    )
  );
}

RoleDetail.propTypes = {
  history: PropTypes.object
};
